import { CartOffer } from "./cartOffer.model";
import { ClassOrString, Parameter, Verylys } from "./verylys";
import { Invoice } from './invoice.model';

export enum CART_STATUS {
    IN_PROGRESS = "IN_PROGRESS",
    SUCCESS = "SUCCESS",
    FAILURE = "FAILURE",
    CHECK_FRAUD = "AWAITING_PAYMENT",
    DISPUTED = "DISPUTED"
}

export interface Cart extends Verylys {
    _id: string;
    friendly_id: string;
    parameters: {
        status: Parameter<CART_STATUS>;
    }

    cart_offers: ClassOrString<CartOffer>[];
    invoice: ClassOrString<Invoice>;

    pricing: {
        total: {
            amount: number,
            format: string;
        },
        sub_total: {
            amount: number;
            format: string;
        },
        tax: {
            amount: number;
            format: string;
        },
    }
}